import {
  Calculator, FileText, TrendingUp, Briefcase, Building2, Layers, ArrowUpRight,
} from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useGoTo } from "@/lib/navigation";

const ICONS = [Calculator, FileText, TrendingUp, Briefcase, Building2, Layers];
const IDS = ["tax-planning", "personal-tax-returns", "capital-gains-tax-advice", "business-consulting", "sme-accounting-support", "integrated-tax-and-accounting"];

export default function Services({ page = false }) {
  const { t } = useLang();
  const s = t.services;
  const scrollTo = useGoTo();
  const Heading = page ? "h1" : "h2";

  return (
    <section id="services" data-testid="services-section" className={`${page ? "pt-36 sm:pt-44 pb-24 sm:pb-32" : "section-y"} bg-cream-100 relative`}>
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="hairline" />
            <span className="text-overline">{s.overline}</span>
          </div>
          <Heading className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-ink-900 tracking-tight">
            {s.h2a}{" "}
            <span className="text-brand-500">{s.h2accent}</span>{s.h2b}
          </Heading>
          <p className="mt-5 text-base sm:text-lg text-ink-500 leading-relaxed">{s.sub}</p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {s.items.map((it, i) => {
            const Icon = ICONS[i];
            const isFeature = i === 0;
            const isLast = i === s.items.length - 1;
            const span = isFeature ? "lg:col-span-2 lg:bg-ink-900 lg:text-white" : isLast ? "lg:col-span-3 bg-white" : "bg-white";
            return (
              <button
                key={IDS[i]}
                data-testid={`service-card-${IDS[i]}`}
                onClick={() => scrollTo("#book")}
                className={`group text-left border border-ink-900/8 hover:border-brand-500 hover:-translate-y-1 transition-all duration-500 p-8 sm:p-10 relative ${span}`}
              >
                <div className="flex items-start justify-between">
                  <div className={`w-12 h-12 grid place-items-center ${isFeature ? "bg-brand-500 text-white lg:bg-brand-500" : "bg-brand-50 text-brand-600"}`}>
                    <Icon className="w-5 h-5" strokeWidth={1.8} />
                  </div>
                  <ArrowUpRight className={`w-5 h-5 ${isFeature ? "text-white/40 lg:text-white/40" : "text-ink-500/50"} group-hover:text-brand-500 group-hover:rotate-12 transition-all duration-300`} />
                </div>
                <h3 className={`mt-7 font-display font-bold text-xl sm:text-2xl ${isFeature ? "text-ink-900 lg:text-white" : "text-ink-900"}`}>{it.title}</h3>
                <p className={`mt-3 text-sm sm:text-base ${isFeature ? "text-ink-500 lg:text-white/70" : "text-ink-500"} leading-relaxed ${isLast ? "max-w-2xl" : ""}`}>
                  {it.blurb}
                </p>
                <div className={`mt-7 pt-5 border-t ${isFeature ? "border-ink-900/8 lg:border-white/10" : "border-ink-900/8"} text-xs uppercase tracking-[0.2em] font-bold text-brand-500`}>
                  {s.discuss}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
